import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE_URL || 'https://api.test2026.uzcloud.uz/';

const API = axios.create({
  baseURL,
  responseType: 'json',
});

export default API;
